import { CloseIcon } from 'assets/icons/CloseIcon'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import { ISelectValue } from 'constants/globalTypes'
import { addCompanyAdmin, editCompanyAdmin } from 'features/companyAdmins/companyAdminsSlice'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'
import useFocusFirstInput from 'utils/useFocusFirstInput'
import { standardFieldValidation, validateSelect } from 'utils/validationUtils'

export const CompanyAdminsModal = ({ closeModal, value }: { closeModal: any, value?: ICompanyAdminsModalState }) => {
    const [state, setState] = useState<ICompanyAdminsModalState>(value || null)
    const [invalidFields, setInvalidFields] = useState(value ? [] : ['firstName', 'lastName', 'phoneNumber', 'email', 'company', 'username'])
    const dispatch = useDispatch<AppDispatch>()
    useFocusFirstInput()
    useModalClose(closeModal)

    const handleSave = async () => {
        const resp = await dispatch(value?.id ? editCompanyAdmin(state) : addCompanyAdmin(state))
        if (resp.meta.requestStatus === 'fulfilled') {
            closeModal()
        }
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target
        standardFieldValidation(e, setInvalidFields)
        setState((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    const handleCompany = (value: ISelectValue, name: string) => {
        validateSelect(value, name, setInvalidFields)
        setState((prev) => ({
            ...prev,
            company: value
        }))
    }

    return <Modal black>
        <Flex column between center >
            <Flex column gap='1rem' width='100%' >
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold' >{value?.id ? 'Edit' : 'Add'} Company Administrator</TitleText>
                    <CursorPointer onClick={closeModal} >
                        <CloseIcon />
                    </CursorPointer>
                </Flex>
                <Flex width='100%' gap='1rem' >
                    <Input name='firstName' placeholder='John...' labelText='First Name' value={state?.firstName} onChange={handleChange} nomarg invalid={invalidFields.includes('firstName')} />
                    <Input name='lastName' placeholder='Smith...' labelText='Last Name' value={state?.lastName} onChange={handleChange} nomarg invalid={invalidFields.includes('lastName')} />
                </Flex>
                <Flex width='100%' gap='1rem' >
                    <Input type='tel' name='phoneNumber' placeholder='+38163762...' labelText='Phone number' value={state?.phoneNumber} onChange={handleChange} nomarg invalid={invalidFields.includes('phoneNumber')} />
                    <Input type='email' name='email' placeholder='john2@gmail.com' labelText='Email' value={state?.email} onChange={handleChange} nomarg invalid={invalidFields.includes('email')} />
                </Flex>
                <Flex width='100%' gap='1rem' >
                    {!value?.id && <Input name='username' placeholder='johnsmith123' labelText='Username' value={state?.username} onChange={handleChange} nomarg invalid={invalidFields.includes('username')} />}
                    <HonestSelectAsyncInput
                        name='company'
                        defaultValue={state?.company?.label}
                        labelText='Company'
                        placeholder='Search Companies...'
                        link='companies/simple'
                        onChange={handleCompany}
                        parserFunction={(data: any) => data.data.map((i: any) => ({ label: i.name, value: i.id }))}
                        invalid={invalidFields.includes('company')}
                    />
                </Flex>
            </Flex>
            <Button disabled={!!invalidFields.length} orange onClick={handleSave} >Save</Button>
        </Flex>
    </Modal>
}

export interface ICompanyAdminsModalState {
    id?: number
    firstName: string
    lastName: string
    username: string
    email: string
    phoneNumber: string
    company: ISelectValue
}